import { useDispatch, useSelector } from 'react-redux';
import { getIsApproving, getApproveError } from '../selectors';
import { approvePpsiNir } from '../actions';

const useApprovePpsiNir = () => {
  const dispatch = useDispatch();
  const isApprovingPpsiNir = useSelector(getIsApproving);
  const approveErrorPpsiNir = useSelector(getApproveError);

  const approvePpsi = (id, data) => {
    dispatch(approvePpsiNir(id, data));
  };

  return [approvePpsi, isApprovingPpsiNir, approveErrorPpsiNir];
};

export default useApprovePpsiNir;
